export class NgxGalleryLayout {
    static ThumbnailsTop = 'thumbnails-top';
    static ThumbnailsBottom = 'thumbnails-bottom';
    static ThumbnailsLeft = 'thumbnails-left';
}
